import React from 'react'
import {Row,Col} from 'react-bootstrap'
import { useSelector} from "react-redux"

const ListaRegulamin = () => {
    const listaregul = useSelector((magazyn) => magazyn.regulamin)
        return(
            <Row>
            <Row>
                <Col xs={12}><h3 className="napis"> Regulamin Testu </h3></Col>
            </Row>
            <Row>
                <Col xs={1}></Col>
                <Col xs={11}>
                <ol key="123" className='font-regulamin'>
                  {listaregul.map(pozycja => (
                      <li key={pozycja.lp}>{pozycja.tekst}</li>
              ))
             }
             </ol>
             </Col>
            </Row>
            </Row>  
        )
}

export default ListaRegulamin